import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {QuantitySettingLine} from "../../models/quantitySettingLine.model";
import {QuantitySettingType} from "../../types/quantitySetting.type";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";

export class ProgramQuantityViewCtrl implements IController {

  program: any;
  groups: any;
  programId: any;
  accountId: any;

  private isSaveAvailable: any;
  private groupKeys: any;

  private hasValue: boolean;
  private quantitySettingLines: QuantitySettingLine[];
  private quantitySettingLinesCopy: QuantitySettingLine[];

  /* @ngInject */
  constructor(private PricePlanService, private commonsAlertsService: CommonsAlertsService) {
  }

  $onInit() {
    this._initValues();
  }

  _initValues() {
    this.isSaveAvailable = false;
    this.groupKeys = this.PricePlanService.generatePreferencesDataGroupKeys(this.program.data);

    this.hasValue = !!_.get(this.groupKeys, 'QuantityDiscount.SpotQuantityDiscount.value.quantityDiscountLines');
    this.quantitySettingLines = this.hasValue ?
      angular.copy(_.get(this.groupKeys, 'QuantityDiscount.SpotQuantityDiscount.value.quantityDiscountLines')) :
      angular.copy(_.get(this.groupKeys, 'QuantityDiscount.SpotQuantityDiscount.parentValue.quantityDiscountLines'))
    this.quantitySettingLinesCopy = angular.copy(this.quantitySettingLines);
  }

  addQuantitySettingLine() {
    const lastLine = _.last(this.quantitySettingLinesCopy);
    const quantitySettingLine: QuantitySettingLine = {
      from: !_.isUndefined(_.get(lastLine, 'to')) ? lastLine.to + 1 : 0,
      to: !_.isUndefined(_.get(lastLine, 'to')) ? lastLine.to + 2 : 10,
      type: QuantitySettingType.Discount,
      value: 0
    }
    this.quantitySettingLinesCopy.push(quantitySettingLine);
    this.onDataChange();
  }

  onAmountChange(quantitySetting, index) {
    if (!_.isUndefined(quantitySetting.from) && this.quantitySettingLinesCopy[index - 1]) {
      this.quantitySettingLinesCopy[index - 1].to = quantitySetting.from - 1;
    }
    if (!_.isUndefined(quantitySetting.to) && this.quantitySettingLinesCopy[index + 1]) {
      this.quantitySettingLinesCopy[index + 1].from = quantitySetting.to + 1;
    }
    this.onDataChange();
  }

  onRemove(index) {
    this.quantitySettingLinesCopy.splice(index, 1);
    this.onDataChange();
  }

  onDataChange() {
    this.isSaveAvailable = !_.isEqual(this.quantitySettingLines, this.quantitySettingLinesCopy);
  }

  onSaveProgram(form) {
    _.forEach(this.quantitySettingLinesCopy, (line, index) => {
      form[index].$setSubmitted();
    })

    if (form.$valid) {
      _.set(this.groupKeys, 'QuantityDiscount.SpotQuantityDiscount.value.quantityDiscountLines', this.quantitySettingLinesCopy)
      const updatedProgram = this.PricePlanService.generatePreferencesDataPayload(this.program, this.groupKeys);
      this.PricePlanService.saveProgramDataByGroups(this.programId, updatedProgram, this.groups, this.accountId)
        .then((updatedProgram) => {
          this.program = updatedProgram;
          this._initValues();
        })
    } else {
      this.commonsAlertsService.formInvalidInfo();
    }
  }

  onCancelChanges(){
    this._initValues();
    this.isSaveAvailable = false;
  }
}

angular
  .module('bringoz.admin.pricePlan')
  .component('programQuantityView', {
    bindings: {
      program: '<',
      groups: '<',
      programId: '<',
      accountId: '<?'
    },
    template: require('./program-quantity-view.html').default,
    controller: ProgramQuantityViewCtrl
  });
